import React from 'react';
import Image from 'next/image';
import informationRoundNext from '../../svgs/info_basic_icon.svg';
import { NextImageProps } from '../NextImageProps';

export function InformationRoundNext({ className, width, height, alt }: NextImageProps) {
  return (
    <Image
      width={width}
      height={height}
      className={className}
      src={informationRoundNext}
      alt={alt ?? 'Information'}
    />
  );
}
